import React, { useState, useEffect } from 'react';
import { useApp } from '../context/AppContext';
import { getAppEvents, updateAppEventStatus, deleteAppEvent } from '../services/api';

const statusBadge = s => ({ active:'badge badge-green', upcoming:'badge badge-blue', cancelled:'badge badge-red', completed:'badge badge-gray' })[s] || 'badge badge-gray';

export default function Events({ toast }) {
  const { token } = useApp();
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState(null);

  const load = async (p=1, s='') => {
    setLoading(true);
    try { const res = await getAppEvents(token, { page:p, limit:20, search:s }); setEvents(res.data||[]); setPagination(res.pagination||null); }
    catch(e) { toast?.(e.message,'error'); } finally { setLoading(false); }
  };

  useEffect(()=>{ load(); },[token]);

  const updateStatus = async (id, status) => {
    try { await updateAppEventStatus(token, id, status, ''); toast?.(`Event ${status}`); load(page,search); }
    catch(e) { toast?.(e.message,'error'); }
  };

  const remove = async (id) => {
    try { await deleteAppEvent(token, id); toast?.('Event deleted'); load(page,search); }
    catch(e) { toast?.(e.message,'error'); }
  };

  return (
    <div>
      <div className="stats-grid">
        <div className="stat-card"><div className="stat-label">Total events</div><div className="stat-value">{pagination?.total??events.length}</div><div className="stat-sub">All events</div></div>
        <div className="stat-card"><div className="stat-label">Active</div><div className="stat-value">{events.filter(e=>e.status==='active').length}</div><div className="stat-sub stat-up">Live</div></div>
        <div className="stat-card"><div className="stat-label">Upcoming</div><div className="stat-value">{events.filter(e=>e.status==='upcoming').length}</div><div className="stat-sub">Scheduled</div></div>
        <div className="stat-card"><div className="stat-label">Completed</div><div className="stat-value">{events.filter(e=>e.status==='completed').length}</div><div className="stat-sub">Done</div></div>
      </div>
      <div style={{ display:'flex', gap:10, marginBottom:16 }}>
        <input className="search-input" placeholder="Search events…" value={search} onChange={e=>setSearch(e.target.value)} onKeyDown={e=>e.key==='Enter'&&load(1,search)} style={{ flex:1 }} />
        <button className="btn btn-ghost" onClick={()=>load(1,search)}>Search</button>
      </div>
      <div className="card" style={{ padding:0 }}>
        <div className="table-wrap">
          <table>
            <thead><tr><th>Event</th><th>Type</th><th>Location</th><th>Date</th><th>Status</th><th>Actions</th></tr></thead>
            <tbody>
              {loading ? <tr><td colSpan={6} style={{ textAlign:'center', padding:40, color:'var(--text-dim)' }}>Loading events…</td></tr>
              : events.length===0 ? <tr><td colSpan={6} style={{ textAlign:'center', padding:40, color:'var(--text-dim)' }}>No events found</td></tr>
              : events.map(e=>(
                <tr key={e.id}>
                  <td><div style={{ fontWeight:500 }}>{e.title||e.name}</div><div style={{ fontSize:11, color:'var(--text-dim)' }}>{e.description?.slice(0,50)}…</div></td>
                  <td style={{ fontSize:12 }}>{e.eventType||e.type||'—'}</td>
                  <td style={{ fontSize:12 }}>{e.location||'—'}</td>
                  <td style={{ fontSize:12, color:'var(--text-dim)' }}>{e.eventDate||e.date?new Date(e.eventDate||e.date).toLocaleDateString():'—'}</td>
                  <td><span className={statusBadge(e.status)}>{e.status}</span></td>
                  <td>
                    <div style={{ display:'flex', gap:6 }}>
                      {e.status!=='cancelled' && <button className="btn btn-ghost" style={{ fontSize:11, color:'var(--danger)' }} onClick={()=>updateStatus(e.id,'cancelled')}>Cancel</button>}
                      {e.status==='upcoming' && <button className="btn btn-ghost" style={{ fontSize:11 }} onClick={()=>updateStatus(e.id,'active')}>Activate</button>}
                      <button className="btn btn-ghost" style={{ fontSize:11, color:'var(--danger)' }} onClick={()=>remove(e.id)}>Delete</button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
